import { CollectionName } from '@/shared/lib/sj-orm';
import { FileMetaInfoDto } from '@/shared/lib/sj-orm/models/file-meta-info.dto';

export const isFileMetaInfoDto = (item: unknown): item is FileMetaInfoDto => {
  return typeof item === 'object' && item !== null && 'id' in item && isFileMetaInfoDtoId(item.id);
};

export const isFileMetaInfoDtoId = (id: unknown) => {
  return typeof id === 'string' && id.startsWith(CollectionName.FILE_META_INFO);
};
